import {TokenName} from './lexical.mjs';

function lineNumber(tokenIterator) {
    return tokenIterator.tokens.slice(0, tokenIterator.index)
        .filter(token => token.name === TokenName.LINE_FEED).length + 1;
}

function syntaxError(line, message) {
    return new SyntaxError(`Course markup line ${line}: ${message}`);
}

function consumeHeadingContent(tokenIterator) {
    tokenIterator.eatTokens(1);
    const parts = [];
    while (tokenIterator.token() && tokenIterator.token().name !== TokenName.LINE_FEED) {
        parts.push(tokenIterator.token().value);
        tokenIterator.eatTokens(1);
    }
    // Leave the line feed to the whitespace rule, so headings never consume another line.
    return parts.join('');
}

export {lineNumber, syntaxError, consumeHeadingContent};
